<template>
  <div>
    <FixedBar :position="positionFixedBar" backgroundColor="#FAFAFC"
      v-show="formDirty && !modal.open && on || showFixed">
      <div :class="{ collapsed: menuCollapsed, notCollapsed: !menuCollapsed }"
        :style="'margin-bottom:' + marginBottom + 'px'">
        <Button _key="cancelSaveCancel" eventName="cancelSaveCancel" title="Cancelar" type="danger" size="small"
          :clicked="cancel" />
        <Button _key="saveSaveCancel" :eventName="eventName" classIcon="fa-solid fa-floppy-disk" title="Salvar"
          type="success" :disabled="forceEnableSave ? false : !isFormValid(formName)" size="medium" />
        <slot></slot>
      </div>
    </FixedBar>
  </div>
</template>
<script>
import FixedBar from "@nixweb/nixloc-ui/src/component/layout/FixedBar.vue";
import Button from "@nixweb/nixloc-ui/src/component/forms/Button";

import { mapState, mapMutations, mapGetters } from "vuex";

export default {
  name: "SaveCancel",
  components: { FixedBar, Button },
  props: {
    formName: String,
    showFixed: {
      type: Boolean,
      default: false,
    },
    eventName: {
      type: String,
      default: "saveSaveCancel",
    },
    positionFixedBar: {
      type: String,
      default: "footer",
    },
    marginBottom: {
      type: Number,
      default: 0,
    },
    forceEnableSave: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      id: this.$route.params.id,
      on: false,
    };
  },
  mounted() {
    if (!this.id) {
      let self = this;
      setTimeout(function () {
        self.resetValidation(this.formName);
        self.updateFormDirty(false);
        self.removeLoading(["panel"]);
      }, 350);
    }

    let self = this;
    setTimeout(function () {
      self.updateFormDirty(false);
      self.on = true;
    }, 1000);
  },
  computed: {
    ...mapState("validation", ["formDirty"]),
    ...mapState("generic", ["loading"]),
    ...mapGetters("generic", ["event"]),
    ...mapGetters("validation", ["isFormValid"]),
    ...mapState("generic", ["modal", "menuCollapsed"]),
  },
  methods: {
    ...mapMutations("validation", ["updateFormDirty", "resetValidation"]),
    ...mapMutations("generic", ["removeLoading", "hideSideBar"]),
    cancel() {
      this.updateFormDirty(false);
      this.removeLoading(["cancelSaveCancel"]);
      this.$root.$emit("bv::toggle::collapse", "my-sidebar");
      this.hideSideBar();
    },
  },
  watch: {
    "modal.open": function () {
      this.updateFormDirty(false);
    },
  },
};
</script>
<style scoped>
.collapsed {
  margin-left: 0px;
  transition: all 0.4s ease;
}

.notCollapsed {
  margin-left: 130px;
  transition: all 0.4s ease;
}
</style>
